import Vue from 'vue';

const state = {
  /**
   * Map of domainId -> actionId -> boolean loading
   * Example: { 'xxx': { 8: true } }
   */
  byDomainId: Object.create(null),
};

function ensureDomainEntry(byDomainId, domainId) {
  if (!byDomainId[domainId]) {
    Vue.set(byDomainId, domainId, Object.create(null));
  }
  return byDomainId[domainId];
}

const mutations = {
  setDomainActionLoading(state, { domainId, actionId, loading }) {
    if (!domainId && domainId !== 0) return;
    if (actionId === undefined || actionId === null) return;

    const domainEntry = ensureDomainEntry(state.byDomainId, String(domainId));
    Vue.set(domainEntry, String(actionId), Boolean(loading));
  },
  setDomainActionLoadingOn(state, { domainId, actionId }) {
    mutations.setDomainActionLoading(state, { domainId, actionId, loading: true });
  },
  setDomainActionLoadingOff(state, { domainId, actionId }) {
    mutations.clearDomainActionLoading(state, { domainId, actionId });
  },
  clearDomainActionLoading(state, { domainId, actionId }) {
    if (!domainId && domainId !== 0) return;
    const key = String(domainId);
    const domainEntry = state.byDomainId[key];
    if (!domainEntry) return;

    if (actionId === undefined || actionId === null) {
      Vue.delete(state.byDomainId, key);
      return;
    }

    const actionKey = String(actionId);
    if (Object.prototype.hasOwnProperty.call(domainEntry, actionKey)) {
      Vue.delete(domainEntry, actionKey);
    }
    if (Object.keys(domainEntry).length === 0) {
      Vue.delete(state.byDomainId, key);
    }
  },
  clearAllDomainActionLoadingForAction(state, { actionId }) {
    if (actionId === undefined || actionId === null) return;
    const actionKey = String(actionId);
    Object.keys(state.byDomainId).forEach((domainId) => {
      const entry = state.byDomainId[domainId];
      if (!entry) return;
      if (Object.prototype.hasOwnProperty.call(entry, actionKey)) {
        Vue.delete(entry, actionKey);
      }
      if (Object.keys(entry).length === 0) {
        Vue.delete(state.byDomainId, domainId);
      }
    });
  },
};

const getters = {
  isDomainActionLoading: (state) => (domainId, actionId) => {
    if (!domainId && domainId !== 0) return false;
    if (actionId === undefined || actionId === null) return false;
    const entry = state.byDomainId[String(domainId)];
    return Boolean(entry && entry[String(actionId)]);
  },
  isAnyDomainLoadingForAction: (state) => (actionId) => {
    if (actionId === undefined || actionId === null) return false;
    const actionKey = String(actionId);
    return Object.keys(state.byDomainId).some((domainId) => {
      const entry = state.byDomainId[domainId];
      return Boolean(entry && entry[actionKey]);
    });
  },
  isDomainLoading: (state) => (domainId) => {
    if (!domainId && domainId !== 0) return false;
    const entry = state.byDomainId[String(domainId)];
    return Object.values(entry || {}).some(Boolean);
  },
  isAnyDomainLoading: (state) => () => {
    // return true if any domain is loading
    return Object.values(state.byDomainId).some((entry) => {
      return Object.values(entry || {}).some(Boolean);
    });
  },
};

export default {
  state,
  mutations,
  getters,
};
